import {
  Button,
  Heading,
  IconClub,
  IconInfo,
  IconPoints,
  IconReturn,
  IconShoppingBag,
} from "@idg-web-platform/pulse";
import css from "./historyPage.module.css";
import { NavigationWrapper } from "../components/navigation/navigationWrapper.tsx";
import { formatDate } from "../utils/formats.ts";
import classNames from "classnames";
import { PointBalanceCard } from "../components/pointBalanceCard/pointBalanceCard.tsx";
import { useEffect, useState } from "preact/hooks";
import { analyticsContentViewed } from "../utils/analyticsContentViewed.ts";
import ClubInformationDialog from "./clubInformationDialog.tsx";

HistoryPage.tagName = "control-club-history-page";

export enum BookingType {
  order,
  return,
  club,
}

export interface Booking {
  type: BookingType;
  date: Date;
  description: string;
  amount: number;
}

export interface HistoryPageProps {
  pointBalance: number;
  exchangeRate: number;
  bookings: Booking[];
}

export function HistoryPage(props: HistoryPageProps) {
  useEffect(() => {
    analyticsContentViewed("club_history");
  }, []);
  const [isClubInformationDialogOpen, setIsClubInformationDialogOpen] = useState(false);

  return (
    <>
      <NavigationWrapper currentPath="/c/club">
        <div className={css.root}>
          <Heading class={css.headline} sizeStep={2}>
            <IconClub /> Punktekonto
          </Heading>

          <PointBalanceCard
            pointBalance={props.pointBalance}
            exchangeRate={props.exchangeRate}
            class={css.pointBalanceCard}
          />

          <Button
            text="Weitere Infos zu CLUB Punkten"
            iconComponent={<IconInfo />}
            iconPosition="right"
            class={css.clubInfoButton}
            onClick={() => {
              setIsClubInformationDialogOpen(true);
            }}
          />
          <ClubInformationDialog
            isOpen={isClubInformationDialogOpen}
            onClose={() => {
              setIsClubInformationDialogOpen(false);
            }}
          />

          <div className={css.bookings} data-dd-privacy="mask">
            {props.bookings.map((booking) => (
              <div className={css.booking} data-testid={"booking-item"}>
                <div className={css.bookingIconContainer} data-testid={"booking-icon"}>
                  {booking.type === BookingType.order && <IconShoppingBag fluid={true} />}
                  {booking.type === BookingType.return && <IconReturn fluid={true} />}
                  {booking.type === BookingType.club && <IconPoints fluid={true} />}
                </div>
                <div className={css.bookingText} data-testid={"booking-date-description"}>
                  <p>{formatDate(booking.date)}</p>
                  <p>{booking.description}</p>
                </div>
                <div
                  className={classNames(
                    css.bookingAmount,
                    booking.amount < 0 ? css.red : undefined,
                  )}
                  data-testid={"booking-amount"}
                >
                  {booking.amount > 0 ? "+" : ""}
                  {booking.amount}
                </div>
              </div>
            ))}
          </div>
        </div>
      </NavigationWrapper>
    </>
  );
}
